import React from 'react';
import PipelineLeak3D from '../three/PipelineLeak3DLazy';

export default function PipelineSection() {
  return (
    <section id="leistungen" className="relative py-16 sm:py-24 md:py-32 border-y border-slate-200/70 overflow-hidden" data-testid="pipeline-section">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="eyebrow mb-5">Visualisierung</div>
          <h2 className="font-display font-black text-slate-900 text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[1.02] mb-6">
            Versteckte Lecks kosten Sie<br />
            <span className="text-[#ff2a55]">Tausende Euro.</span>
          </h2>
          <p className="text-slate-600 text-base sm:text-lg leading-relaxed mb-8">
            Was das menschliche Ohr nicht hört, machen unsere High-End Geräte sichtbar. Jeder leuchtende
            Punkt im Rohrleitungssystem ist ein quantifiziertes Leck – inklusive Volumenstrom und Kosten
            pro Jahr.
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-4 py-3 border-b border-slate-200/70">
              <div className="w-2 h-2 bg-[#ff2a55] animate-pulse" />
              <div className="flex-1 font-mono-tech text-sm text-slate-700">LECK · 3.5 mm</div>
              <div className="font-mono-tech text-sm text-[#ff2a55]">4.120 € / Jahr</div>
            </div>
            <div className="flex items-center gap-4 py-3 border-b border-slate-200/70">
              <div className="w-2 h-2 bg-[#ff2a55] animate-pulse" />
              <div className="flex-1 font-mono-tech text-sm text-slate-700">LECK · 2.3 mm</div>
              <div className="font-mono-tech text-sm text-[#ff2a55]">1.840 € / Jahr</div>
            </div>
            <div className="flex items-center gap-4 py-3 border-b border-slate-200/70">
              <div className="w-2 h-2 bg-[#ff8a00] animate-pulse" />
              <div className="flex-1 font-mono-tech text-sm text-slate-700">LECK · 1.1 mm</div>
              <div className="font-mono-tech text-sm text-[#ff8a00]">720 € / Jahr</div>
            </div>
            <div className="flex items-center gap-4 py-3">
              <div className="w-2 h-2 bg-[#00ff66]" />
              <div className="flex-1 font-mono-tech text-sm text-slate-900 font-semibold">SUMME · 3 Lecks</div>
              <div className="font-mono-tech text-sm text-[#00ff66] font-semibold">6.680 € / Jahr</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2 relative">
          <div className="border border-slate-200 bg-[#ffffff]/60 backdrop-blur-sm rounded-sm overflow-hidden">
            <div className="flex items-center justify-between px-4 py-2 border-b border-slate-200">
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-500">
                SCAN.LIVE · ANLAGE-04 · DRUCKLUFT 6.5 BAR
              </div>
              <div className="font-mono-tech text-[10px] text-[#00ff66]">● ONLINE</div>
            </div>
            <PipelineLeak3D />
          </div>
        </div>
      </div>
    </section>
  );
}
